import { render, staticRenderFns } from "./AutoShow2023.vue?vue&type=template&id=5b8d303b&scoped=true&"
import script from "./AutoShow2023.vue?vue&type=script&lang=js&"
export * from "./AutoShow2023.vue?vue&type=script&lang=js&"
import style0 from "./AutoShow2023.vue?vue&type=style&index=0&id=5b8d303b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8d303b",
  null
  
)

export default component.exports